import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@breakout/ui/components/DropdownMenu"
import { cn } from "@breakout/ui/utils"
import { Laptop, Moon, Sun } from "lucide-react"
import { useTheme } from "./ThemeProvider"

export function ThemeToggle() {
	const { setTheme, theme, resolvedTheme } = useTheme()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<button
					aria-label="Toggle theme"
					className="flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-xl border border-border-highlight bg-bg-tertiary text-text-primary transition-all hover:bg-bg-secondary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-breakout-brand active:scale-95"
					type="button"
				>
					{resolvedTheme === "dark" ? (
						<Moon aria-hidden="true" className="size-5" />
					) : (
						<Sun aria-hidden="true" className="size-5" />
					)}
				</button>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				align="end"
				className="z-[var(--z-dropdown)] min-w-[8rem] border-border-subtle bg-bg-card shadow-xl"
			>
				<DropdownMenuItem
					className={cn(theme === "light" && "bg-bg-tertiary text-text-primary")}
					onClick={() => setTheme("light")}
				>
					<Sun aria-hidden="true" className="mr-2 h-4 w-4" />
					Light
				</DropdownMenuItem>
				<DropdownMenuItem
					className={cn(theme === "dark" && "bg-bg-tertiary text-text-primary")}
					onClick={() => setTheme("dark")}
				>
					<Moon aria-hidden="true" className="mr-2 h-4 w-4" />
					Dark
				</DropdownMenuItem>
				<DropdownMenuItem
					className={cn(theme === "system" && "bg-bg-tertiary text-text-primary")}
					onClick={() => setTheme("system")}
				>
					<Laptop aria-hidden="true" className="mr-2 h-4 w-4" />
					System
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
